import React from 'react';

import { IconAlert, IconClose, IconHand, IconTag, IconTransfer } from './icons';

import { IconWrapper, Label, StyledAssetHistoryStatus } from './AssetHistoryStatus.style';

// TODO: What is the difference between `cancel` and `cancelled`?
export type AssetHistoryStatusType = 'cancel' | 'cancelled' | 'list' | 'offer' | 'transfer';

export interface AssetHistoryStatusProps {
    type: AssetHistoryStatusType;
}

function getIcon(type: AssetHistoryStatusType) {
    switch (type) {
        case 'cancel':
            return IconClose;
        case 'cancelled':
            return IconAlert;
        case 'list':
            return IconTag;
        case 'offer':
            return IconHand;
        case 'transfer':
        default:
            return IconTransfer;
    }
}

const label: Record<AssetHistoryStatusType, string> = {
    // TODO: This should probably be in `i18n`.
    cancel: 'Cancel',
    cancelled: 'Cancelled',
    offer: 'Offer',
    list: 'List',
    transfer: 'Transfer',
};

export function AssetHistoryStatus({ type }: AssetHistoryStatusProps) {
    const Icon = getIcon(type);

    return (
        <StyledAssetHistoryStatus>
            <IconWrapper>
                <Icon />
            </IconWrapper>

            <Label>{label[type]}</Label>
        </StyledAssetHistoryStatus>
    );
}
